<template>
    <div class="footer">
        <img src="/abc/static/footer.png" class="footer-img"/>
        <div class="footer-info">

            <div class="footer-left">
                <div class="footer-logo" v-if="foot.footerLogoUrl">
                    <img v-if="foot.footerLogoUrl" :src="foot.footerLogoUrl"/>
                </div>
                <div class="footer-qrcode-list">
                    <div class="footer-qrcode" v-for="item in qrcodeList" v-bind:key="item.id">
                        <div class="wechat-qrcode qrcode">
                            <img v-lazy="item.imageUrl"/>
                        </div>
                        <div class="wechat-name qrcode-name">
                            {{item.imageDesc}}
                        </div>
                    </div>
                </div>
             </div>
            <div class="footer-name">
                <div class="footer-title-block">
                    <div class="footer-title">赛事官方单位</div>
                    <div class="divider"></div>
                </div>
                <div class="info-box" v-for="(item, index) in foot.footers" v-bind:key="item.footerId" :style="(index == foot.footers.length-1)?'margin-bottom:108px':''">
                    <div class="footer-name-type">{{item.footerName}}</div>
                    <div class="footer-com" v-if="item.linkUrl && item.linkUrl != ''"><a :href="item.linkUrl">{{item.footerContent}}</a></div>
                    <div class="footer-com" v-else>{{item.footerContent}}</div>
                </div>
                <div class="footer-beian">
                   <span style="margin-right: 12px;">富弈广告©版权所有</span>
                    <a href="http://beian.miit.gov.cn" target="_blank">
                        <img src="@/../static/icon_gongxin.png"/>
                        <span class="lh s-bottom-recordcode">{{foot.beianGongxin}}</span>
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="http://www.beian.gov.cn/" target="_blank">
                        <img src="@/../static/icon_gongan.png"/>
                        <span class="lh s-bottom-recordcode">{{foot.beianGongan}}</span>
                    </a>
                </div>

            </div>

        </div>

        
    </div>
</template>

<script>
export default {
    props:{
        foot:{
            type:Object
        },
        qrcodeList:{
            type:Array
        }
    }
}
</script>

<style scoped>
.footer{
    position: relative;
    max-width: 1920px;
    min-width: 1200px;
    background-color: #183C79;
    /* background: url('/abc/static/footer.jpg') 100% 100% no-repeat; */
}
.footer-img{
    position: absolute;
    height: 100%;
}
.footer-left{
    width: 310px;
    /* padding-left: 200px; */
}
.footer-info{
    width: 1200px;
    margin: 0 auto;
}
.footer-logo{
    padding-top: 90px;
    text-align: center;
    margin-bottom: 16px;
}
.footer-info{
    margin-top: 70px;
    position: relative;
    display: flex;
    height: 100%;
}
.footer-info>div{
    display: inline-block;
}
.footer-qrcode{
    text-align: center;
    margin-top: 32px;
    width: 50%;
}
.qrcode-name{
    margin-top: 12px;
    color: white;
}
.footer-qrcode-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    width: 232px;
    margin: 0 auto;
    
}
.qrcode img{
    width: 94px;
    height: 94px;
}
.footer-weibo{
    margin-left: 40px;
}
.footer-title{
    color: white;
    font-size: 18px;
    font-weight: bold;
}
.divider{
    height: 1px;
    background: #9390b2;
    margin-top: 10px;
    width: 440px;
}
.info-box:nth-child(2){
    margin-top: 24px;
}
.footer-name{
    width: 890px;
    color: white;
    font-size: 14px;
    font-weight: bold;
    font-family: 'Microsoft YaHei';
    line-height: 22px;
    margin-top: 108px;
    position: relative;
}
.footer-name-type, .footer-com{
    display: block;
}
.footer-name-type{
    font-size: 18px;
}
.info-box{
    margin-bottom: 26px;
}
.footer-beian{
    width: 100%;
    text-align: right;
    color: white;
    font-size: 14px;
    margin-top: 20px;
    position: absolute;
    bottom: 4px;
}
.footer-com{
    margin-top: 6px;
}
.footer-com a{
    color:white;
}
.footer-beian a{
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue